const devNavLinks = [
  {
    id: 0,
    title: 'Documentation',
    url: '/developers/documentation/',
    isHeaderLight: false,
  },
  {
    id: 1,
    title: 'Schema Reference',
    url: 'https://marvelapp.github.io/apidoc/ref/',
    isHeaderLight: false,
  },
  {
    id: 2,
    title: 'Playground',
    url: 'https://marvelapp.com/graphql',
    isHeaderLight: false,
  },
];

export default devNavLinks;



// WEBPACK FOOTER //
// ./src/configs/devNavLinks.js